import { useCallback, useEffect } from 'react'

import { OAUTH_CHANNEL_NAME } from './oauth-channel.const'
import type { OAuthMessageData } from './oauth-message.interface'

/**
 * Subscribes to the OAuth BroadcastChannel and dispatches messages
 * to the appropriate success or error handler.
 */
export const useOAuthChannel = (
  onCallback: (code: string, state: string) => void,
  onError: (errorMessage: string) => void
): void => {
  const handleMessage = useCallback(
    (data: OAuthMessageData) => {
      if (data?.type === 'oauth-error') {
        onError(data.error ?? 'OAuth cancelled')
        return
      }

      if (data?.type === 'oauth-callback' && data.code && data.state) {
        onCallback(data.code, data.state)
      }
    },
    [onCallback, onError]
  )

  useEffect(() => {
    const channel = new BroadcastChannel(OAUTH_CHANNEL_NAME)
    channel.onmessage = (event: MessageEvent<OAuthMessageData>) => handleMessage(event.data)
    return () => channel.close()
  }, [handleMessage])
}
